import currencyFormatter from "currency-formatter";
import { div, round } from "./math";
import { matchRegex } from "./regex";

export const CURRENCIES = [
  "ADP",
  "AED",
  "AFA",
  "AFN",
  "ALK",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "AOK",
  "AON",
  "AOR",
  "ARA",
  "ARP",
  "ARS",
  "ARY",
  "ATS",
  "AUD",
  "AWG",
  "AYM",
  "AZM",
  "AZN",
  "BAD",
  "BAM",
  "BBD",
  "BDT",
  "BEC",
  "BEF",
  "BEL",
  "BGJ",
  "BGK",
  "BGL",
  "BGN",
  "BHD",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BOP",
  "BOV",
  "BRB",
  "BRC",
  "BRE",
  "BRL",
  "BRN",
  "BRR",
  "BSD",
  "BTN",
  "BUK",
  "BWP",
  "BYB",
  "BYN",
  "BYR",
  "BZD",
  "CAD",
  "CDF",
  "CHC",
  "CHE",
  "CHF",
  "CHW",
  "CLF",
  "CLP",
  "CNY",
  "COP",
  "COU",
  "CRC",
  "CSD",
  "CSJ",
  "CSK",
  "CUC",
  "CUP",
  "CVE",
  "CYP",
  "CZK",
  "DDM",
  "DEM",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "ECS",
  "ECV",
  "EEK",
  "EGP",
  "ERN",
  "ESA",
  "ESB",
  "ESP",
  "ETB",
  "EUR",
  "FIM",
  "FJD",
  "FKP",
  "FRF",
  "GBP",
  "GEK",
  "GEL",
  "GHC",
  "GHP",
  "GHS",
  "GIP",
  "GMD",
  "GNE",
  "GNF",
  "GNS",
  "GQE",
  "GRD",
  "GTQ",
  "GWE",
  "GWP",
  "GYD",
  "HKD",
  "HNL",
  "HRD",
  "HRK",
  "HTG",
  "HUF",
  "IDR",
  "IEP",
  "ILP",
  "ILR",
  "ILS",
  "INR",
  "IQD",
  "IRR",
  "ISJ",
  "ISK",
  "ITL",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KPW",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAJ",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "LSM",
  "LTL",
  "LTT",
  "LUC",
  "LUF",
  "LUL",
  "LVL",
  "LVR",
  "LYD",
  "MAD",
  "MDL",
  "MGA",
  "MGF",
  "MKD",
  "MLF",
  "MMK",
  "MNT",
  "MOP",
  "MRO",
  "MRU",
  "MTL",
  "MTP",
  "MUR",
  "MVQ",
  "MVR",
  "MWK",
  "MXN",
  "MXP",
  "MXV",
  "MYR",
  "MZE",
  "MZM",
  "MZN",
  "NAD",
  "NGN",
  "NIC",
  "NIO",
  "NLG",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEH",
  "PEI",
  "PEN",
  "PES",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PLZ",
  "PTE",
  "PYG",
  "QAR",
  "RHD",
  "ROK",
  "ROL",
  "RON",
  "RSD",
  "RUB",
  "RUR",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SDD",
  "SDG",
  "SDP",
  "SEK",
  "SGD",
  "SHP",
  "SIT",
  "SKK",
  "SLL",
  "SOS",
  "SRD",
  "SRG",
  "SSP",
  "STD",
  "STN",
  "SUR",
  "SVC",
  "SYP",
  "SZL",
  "THB",
  "TJR",
  "TJS",
  "TMM",
  "TMT",
  "TND",
  "TOP",
  "TPE",
  "TRL",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "UAK",
  "UGS",
  "UGW",
  "UGX",
  "USD",
  "USN",
  "USS",
  "UYI",
  "UYN",
  "UYP",
  "UYU",
  "UYW",
  "UZS",
  "VEB",
  "VEF",
  "VES",
  "VNC",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XAG",
  "XAU",
  "XBA",
  "XBB",
  "XBC",
  "XBD",
  "XCD",
  "XDR",
  "XEU",
  "XFO",
  "XFU",
  "XOF",
  "XPD",
  "XPF",
  "XPT",
  "XRE",
  "XSU",
  "XTS",
  "XUA",
  "XXX",
  "YDD",
  "YER",
  "YUD",
  "YUM",
  "YUN",
  "ZAL",
  "ZAR",
  "ZMK",
  "ZMW",
  "ZRN",
  "ZRZ",
  "ZWC",
  "ZWD",
  "ZWL",
  "ZWN",
  "ZWR",
] as const;

export const CRYPTO_CURRENCIES = [
  "ETH",
  "BTC",
  "USDT",
  "AVAX",
  "USDC",
] as const;

export type CryptoCurrency = (typeof CRYPTO_CURRENCIES)[number];

export type Currency = (typeof CURRENCIES)[number];

export const DEFAULT_CURRENCY: Currency = "USD";

export const formatPrice = (
  amount: number,
  currency: Currency = DEFAULT_CURRENCY
) => {
  currency = toCurrency(currency);
  const fallback = `${amount} ${currency}`;
  try {
    const formatted = currencyFormatter.format(amount, {
      code: currency,
    });
    if (!formatted) return fallback;

    // no only $ to prevent ambiguity
    if (matchRegex(/(^\$)|([^a-z]\$$)/gim, formatted)) {
      if (currency === "USD") return "US" + formatted;
      return fallback;
    }

    return formatted;
  } catch (error) {
    return fallback;
  }
};

export const USD_FX_RATES: { [currency in Currency]?: number } = {
  USD: 1,
  HKD: 7.8,
  EUR: 0.95,
  THB: 35,
  JPY: 140,
};

export const toUSD = (currency: Currency, amount: number) => {
  try {
    currency = toCurrency(currency);
    const rate = USD_FX_RATES[currency];
    if (!rate) return 0;
    return round(div(amount, rate), 2);
  } catch (error) {}
  return 0;
};

export const toCurrency = (currency?: string): Currency => {
  try {
    if (!currency) return DEFAULT_CURRENCY;
    currency = currency.trim().toUpperCase();
    if (CURRENCIES.includes(currency as any)) return currency as Currency;
  } catch (error) {}
  return DEFAULT_CURRENCY;
};
